// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const houndour: PokeData = {
  "id": 228,
  "name": "houndour",
  "height": 6,
  "weight": 108,
  "base_experience": 66,
  "types": [
    PokeType.DARK,
    PokeType.FIRE
  ],
  "api_moves": [
    "leer",
    "bite",
    "roar",
    "ember",
    "flamethrower",
    "smog",
    "feint-attack",
    "crunch",
    "beat-up",
    "torment",
    "taunt",
    "odor-sleuth",
    "howl",
    "payback",
    "embargo",
    "nasty-plot",
    "fire-fang",
    "flame-charge",
    "foul-play",
    "incinerate",
    "inferno",
    "comeuppance"
  ],
  "moves": [
    "leer",
    "bite",
    "ember",
    "flamethrower",
    "crunch",
    "fire-fang",
    "blaze-kick",
    "pursuit",
    "phantom-force",
    "night-slash",
    "dark-bargain",
    "morning-sun",
    "flare-blitz"
  ],
  "evolution_chain": {
    "id": 118,
    "item": null,
    "species": [
      {
        "name": "houndour",
        "order": 261,
        "types": [
          PokeType.DARK,
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "houndoom",
        "order": 262,
        "types": [
          PokeType.DARK,
          PokeType.FIRE
        ],
        "evolves_from_species_id": 228,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 24,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 42.5,
    "speed": 65,
    "ability_power": 80
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
